import { AP_SCOPE_HEADERS } from '@cash-web/grant-flow-ui-shared'
import { OptionalRequestHeaders } from '@cash-web/shared-util-fetch'

export const hasGrantFlowIntent = () => {
  const currentUrl = new URL(window.location.href)
  if (currentUrl.pathname.startsWith('/grant-flow')) {
    return true
  }

  return false
}

export const hasOONIntent = () => {
  return window.context === 'OON_P2P'
}

export const hasLocalIntent = () => {
  if (window.context !== 'CASH_LOCAL') {
    return false
  }

  const redirectSearchParamKey = Array.from(new URLSearchParams(window.location.search).keys()).find(
    key => key === 'redirect_to'
  )

  if (redirectSearchParamKey) {
    return false
  }

  return true
}

export const optionalScopeHeaders = (): OptionalRequestHeaders | undefined => {
  if (hasOONIntent()) {
    return {
      'x-web-scope': 'oon',
      'x-web-tenant': 'oon',
    }
  } else if (hasGrantFlowIntent()) {
    return AP_SCOPE_HEADERS
  } else if (hasLocalIntent()) {
    return { 'x-web-scope': 'local' }
  }

  return undefined
}
